import Mock from 'mockjs'
import faker from 'faker'
import moment from 'moment'
import remove from 'lodash/remove'
import clone from 'lodash/clone'
import {Freight} from "@/models/freight";

const GENERATE_FREIGHTS_ON_DATE = false

function genRecentFlightDateIso (recent) {
  let flightDate = faker.date.recent(recent)
  flightDate = new Date(parseInt(flightDate.getTime() / (1000 * 60 * 60 * 24)) * 1000 * 60 * 60 * 24)
  return moment(flightDate).utc(false).toISOString()
}

function genFreight (flightDate) {
  const freight = {
    id: faker.random.number({min: 1000, max: 10000}),
    version: faker.random.number(100),
    flightDate: flightDate || genRecentFlightDateIso(3),
    ak: ['UT', 'Ya'][faker.random.number(1)],
    bortType: ['8T', '8MTV'][faker.random.number(1)],
    bort: null,
  }
  return freight
}

const freightsOnDate = {}
const flightOrders = {}

const List = []
const count = 100

const baseContent = '<p>I am testing data, I am testing data.</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>'
const image_uri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3'

function genFreightList (count, flightDate) {
  const freights = []
  for (let i = 0; i < count; i++) {
    freights.push(genFreight(flightDate))
  }
  return freights
}
List.push(genFreightList(100, null))

/*
for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: '@increment',
    // timestamp: +Mock.Random.date('T'),
    flightDate: genRecentFlightDateIso(3),

    author: '@first',
    reviewer: '@first',
    title: '@title(5, 10)',
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'status|1': ['published', 'draft', 'deleted'],
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}
*/

function removeNewOrders(freight) {
  freight.flights.forEach(flight => {
    flight.newOrders = []
  })
}
function removeDeletedOrders(freight) {
  const flightOrderIdsMap = freight.flights.reduce((acc, flight) => {
    // clone to have no affect when remove items from flight.deleteOrders
    flight.deleteOrders.length > 0 && (acc[flight.leg] = clone(flight.deleteOrders))
    return acc
  }, {})
  Object.keys(flightOrderIdsMap).forEach(legNum => {
    const leg = parseInt(legNum)
    const { flight } = freight.getFlightByLeg(leg)
    const flightOrderIds = flightOrderIdsMap[leg]

    for(let flightOrderId of flightOrderIds) {
      const { order, index } = flight.getOrder(flightOrderId)
      if (!order) {
        return
      }
      flight.orders.splice(index, 1)
      remove(flight.deleteOrders, deleteOrderId => deleteOrderId === flightOrderId)
    }

  })
}

export default [
  {
    url: '/app/freights',
    type: 'get',
    response: config => {
      const { flightDate } = config.query

      if (!flightDate) return []

      if (GENERATE_FREIGHTS_ON_DATE && !freightsOnDate[flightDate])  {
        const countOnDate = faker.random.number({min: 1, max: 5})
        freightsOnDate[flightDate] = genFreightList(countOnDate, flightDate)
      }

      return freightsOnDate[flightDate] || []
    }
  },

  {
    url: '/app/freights',
    type: 'post',
    response: config => {
      const freights = config.body.map(freightJson => Freight.assign(freightJson))
      console.log('[mock] freights: %o', freights)

      // first convert and check
      freights.forEach(freight => {
        const { id, version, flightDate } = freight
        const baseFreight =  freightsOnDate[flightDate] && freightsOnDate[flightDate].find(freight => freight.id === id)
        if (!baseFreight && freight.version !== 0) {
          throw new Error(`I\'m sorry, Bro. But freight#${id} does not exist`)
        }
        if (baseFreight && baseFreight.version !== version) {
          throw new Error(`Attention, Bro! Expected base version ${version}, but it\'s already updated to ${baseFreight.version}`)
        }
      })

      const uuids = {}

      // then update
      freights.forEach(freight => {
        const { id, flightDate } = freight
        let { version } = freight
        let baseFreight =  freightsOnDate[flightDate] && freightsOnDate[flightDate].find(freight => freight.id === id)

        // create id for new freight
        const isNewFreight = version === 0
        if (isNewFreight) {
          const uuid = freight.uuid
          freight.id = faker.random.number({min: 1000, max: 10000})
          delete freight.uuid
          baseFreight = freight
          uuids[freight.id] = uuid
        }

        version++
        freight.version = version

        // store orders in map
        freight.getOrders().forEach(flightOrder => {
          delete flightOrder.isNew
          delete flightOrder.isDeletePending
          flightOrders[flightOrder.id] = flightOrder
        })

        Object.assign(baseFreight, freight)

        // remove new order ids
        removeNewOrders(freight)
        // remove deleted
        removeDeletedOrders(freight)

        if (isNewFreight) {
          !freightsOnDate[flightDate] && (freightsOnDate[flightDate] = [])
          freightsOnDate[flightDate].push(baseFreight)
        }
      })

      return freights.map(freight => ({
        id: freight.id,
        version: freight.version,
        uuid: uuids[freight.id],
        // errorCode ?
        // errorMessage ?
        // actual: {...}
      }))
    }
  }
]




//////////////////
// WEBPACK FOOTER
// ./mock/freight.js
// module id = null
// module chunks = 